import { render } from "./LeaveListTable.vue?vue&type=template&id=2bc05c75&scoped=true"
import script from "./LeaveListTable.vue?vue&type=script&lang=js"
export * from "./LeaveListTable.vue?vue&type=script&lang=js"

import "./LeaveListTable.vue?vue&type=style&index=0&id=2bc05c75&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc05c75"]])

export default __exports__